import { makeStyles, TextField } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import tw from 'twin.macro';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import LoginRequestModal from '../../LoginRequestModal';
import ResendEmailDropdown from '../../ResendEmailDropdown';

const textareaInputStyles = makeStyles(({
  input: {
    '&': tw`text-black font-body`,
  },
}));

const EmailToClientDetails = ({
  createdFor,
  fromEmail,
  emailRecipients,
  emailSubject,
  emailMessage,
  headerPrefix,
  brochureId,
  compareId,
  pageHeading,
  pageSubHeading,
  doHideMessageBoxInPage,
  isSavedToDatabase,
}) => {
  const router = useRouter();
  const textareaInputClasses = textareaInputStyles();
  const { isLoggedIn } = useSelector((store) => store.user);
  const doHideEmailMessageDivs = !!(emailMessage !== undefined && typeof emailMessage === 'string' && emailMessage.trim().length < 1);

  const [doShowLoginModal, setDoShowLoginModal] = useState(false);
  const isBrochurePage = router.pathname.indexOf('brochure') > -1;
  const isComparePage = router.pathname.indexOf('compare') > -1;
  const doRenderResendEmailDropdown = !!(
    isLoggedIn
    && (brochureId || compareId)
    && (isBrochurePage || isComparePage)
  );

  if (isComparePage) ;
  else if (!isBrochurePage && !isSavedToDatabase) return <></>;
  return (
    <>
      <div className="col-span-3 sm:text-3xl text-xl py-8 w-full border-b-2 border-theme mb-5 text-theme font-semibold px-5 sm:px-0 ">
        <div className="flex justify-between items-center">
          <span className="text-heading font-heading">
            {pageHeading ? (
              <>
                {pageHeading}
              </>
            ) : (
              <>
                {headerPrefix}
                {' '}
                {createdFor}
                {' '}
                {emailRecipients && (
                <span className="break-words">{emailRecipients[0]}</span>
                )}
              </>
            )}
          </span>
          {doRenderResendEmailDropdown && (
          <div className="text-lg">
            <ResendEmailDropdown
              brochureId={brochureId}
              compareId={compareId}
            />
          </div>
          )}
        </div>
        {doShowLoginModal && (
          <LoginRequestModal
            onCancel={() => setDoShowLoginModal(false)}
            actionName="resend email"
          />
        )}
        {!pageSubHeading ? <></>
          : (
            <div className="text-lg italic font-normal">
              <span className="text-subHeading font-subHeading">
                {pageSubHeading}
              </span>
            </div>
          )}
      </div>
      {doHideMessageBoxInPage ? <></>
        : (
          <div className="inline-block w-full col-span-3 bg-white rounded sm:p-5 p-2 text-sm sm:text-base">
            <div className="grid grid-cols-4 break-words ">
              <div className="font-bold">
                <span className="font-smallerHeading text-smallerHeading">
                  From:
                </span>
              </div>
              <div className="col-span-3 pl-5">
                <a
                  href={`mailto:${(emailRecipients || []).join(
                    ';',
                  )}?subject=${emailSubject}`}
                  className="text-theme"
                >
                  {fromEmail}
                </a>
              </div>
              <div className="font-bold"><span className="font-smallerHeading text-smallerHeading"> Recipients:</span></div>
              <div className="col-span-3 pl-5">
                {(emailRecipients || []).join(', ')}
              </div>
              <div className="font-bold"><span className="font-smallerHeading text-smallerHeading">Email subject:</span></div>
              <div className={clsx('col-span-3 pl-5', { 'mb-5': doHideEmailMessageDivs })}>{emailSubject}</div>
              {!doHideEmailMessageDivs
                  && (
                    <>
                      <div className="font-bold"><span className="font-smallerHeading text-smallerHeading">Email message:</span></div>
                      <div className="col-span-3 pl-5">
                        <TextField
                          name="emailMessage"
                          multiline
                          disabled
                          className="w-full h-full"
                          rows={10}
                          InputProps={{ disableUnderline: true, classes: textareaInputClasses }}
                          value={emailMessage}
                        />
                      </div>
                    </>
                  )}
            </div>
          </div>
        )}
    </>
  );
};

EmailToClientDetails.propTypes = {
  createdFor: PropTypes.string,
  fromEmail: PropTypes.string,
  emailRecipients: PropTypes.arrayOf(PropTypes.string),
  emailSubject: PropTypes.string,
  emailMessage: PropTypes.string,
  headerPrefix: PropTypes.string,
  brochureId: PropTypes.string,
  compareId: PropTypes.string,
  pageHeading: PropTypes.string,
  pageSubHeading: PropTypes.string,
  doHideMessageBoxInPage: PropTypes.bool,
  isSavedToDatabase: PropTypes.bool,
};

EmailToClientDetails.defaultProps = {
  createdFor: undefined,
  fromEmail: undefined,
  emailRecipients: [],
  emailSubject: undefined,
  emailMessage: undefined,
  headerPrefix: '',
  brochureId: undefined,
  compareId: undefined,
  pageHeading: '',
  pageSubHeading: '',
  doHideMessageBoxInPage: false,
  isSavedToDatabase: false,
};

export default EmailToClientDetails;
